<template>
  <q-page padding>
    <base-form :resource="$route.meta.resource" :id="this.$route.params.id" :readonly="readonly"/>
  </q-page>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EditForm',
  computed: {
    ...mapGetters('auth', ['user', 'roles', 'hasRole']),
    readonly () {
      if (this.hasRole('Super Admin') || this.hasRole('Super Admin') || this.hasRole('Super Admin')) {
        return false
      }
      return true
    }
  }
}
</script>

<style>
</style>
